export default __webpack_public_path__ + "5367cd70cd9bf33d43b1c72a954904bf.png";